import React from "react";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Container,
  Row,
  Col
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

const CONTACT_API_URL = "https://923hbf7t89.execute-api.us-east-1.amazonaws.com/Prod/contact";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      message: '',
      isSubmitting: false,
      submitStatus: null
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    setPageMeta({
      title: "Contact",
      description:
        "Get in touch with Chisp about a data consulting engagement or an IoT monitoring deployment.",
      path: "/contact",
    });
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({ [name]: value });
  };

  submitToContactAPI = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true, submitStatus: null });

    const { name, email, message } = this.state;
    const data = {
      name: name || 'Not specified',
      email,
      message,
      subject: 'Chisp Website Contact Form'
    };

    fetch(CONTACT_API_URL, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Network response was not ok');
    }).then((data) => {
      this.setState({
        email: '',
        name: '',
        message: '',
        isSubmitting: false,
        submitStatus: 'success'
      });
    }).catch((error) => {
      console.error('Contact form submission error:', error);
      this.setState({
        isSubmitting: false,
        submitStatus: 'error'
      });
    });
  };

  render() {
    const { email, name, message, isSubmitting, submitStatus } = this.state;

    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <DemoNavbar />
          <main ref="main" style={{ flex: '1 0 auto' }}>
            {/* Header Section with Bubbles */}
            <section className="section section-lg section-shaped pb-0" style={{ background: 'linear-gradient(135deg, #7b7be5 0%, #7f6edb 100%)', minHeight: '600px', position: 'relative', zIndex: 1, paddingBottom: '120px' }}>
              <div className="shape shape-style-1 shape-chisp-navy">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '320px', position: 'relative', zIndex: 2, paddingBottom: '40px' }}>
                <h1 className="display-3 text-white text-center mb-2">Contact Us</h1>
                <p className="lead text-white text-center mb-4" style={{ maxWidth: 700 }}>
                  We'd love to hear from you! Fill out the form below and we'll get back to you as soon as possible.
                </p>
              </Container>
            </section>
            {/* Overlapping Card Section */}
            <section style={{ background: '#fff', minHeight: '400px', position: 'relative', zIndex: 2, paddingTop: '0', paddingBottom: '60px' }}>
              <Container style={{ position: 'relative' }}>
                <Row className="justify-content-center">
                  <Col lg="8">
                    <Card className="shadow border-0 bg-gradient-secondary" style={{ color: '#232b4d', borderRadius: '1.25rem', marginTop: '-240px', zIndex: 3, position: 'relative', boxShadow: '0 8px 32px rgba(44,62,80,0.18)' }}>
                      <CardBody className="p-lg-5" style={{ minHeight: '520px' }}>
                        {submitStatus === 'success' ? (
                          <div className="text-center py-5">
                            <i className="fa fa-check-circle fa-4x mb-4" style={{ color: '#2dce89' }}></i>
                            <h3 className="mb-3">Message Sent!</h3>
                            <p className="mb-4">Thanks for reaching out! We'll get back to you soon.</p>
                            <Button
                              className="btn-round"
                              color="default"
                              onClick={() => this.setState({ submitStatus: null })}
                            >
                              Send Another Message
                            </Button>
                          </div>
                        ) : (
                          <>
                            <h3 className="text-center mb-4">Get In Touch</h3>
                            {submitStatus === 'error' && (
                              <div className="alert alert-danger text-center mb-4">
                                Sorry, something went wrong and your message was not sent.
                                Please try again in a moment.
                              </div>
                            )}
                            <Form onSubmit={this.submitToContactAPI}>
                              <FormGroup>
                                <label htmlFor="contactEmail" className="form-label">Email Address *</label>
                                <Input
                                  type="email"
                                  name="email"
                                  id="contactEmail"
                                  placeholder="your_email@example.com"
                                  value={email}
                                  onChange={this.handleChange}
                                  required
                                />
                              </FormGroup>
                              <FormGroup>
                                <label htmlFor="contactName" className="form-label">Name / Organization</label>
                                <Input
                                  type="text"
                                  name="name"
                                  id="contactName"
                                  placeholder="Your name or company"
                                  value={name}
                                  onChange={this.handleChange}
                                />
                              </FormGroup>
                              <FormGroup className="mb-4">
                                <label htmlFor="contactMessage" className="form-label">Message *</label>
                                <Input
                                  type="textarea"
                                  name="message"
                                  id="contactMessage"
                                  placeholder="How can we help you?"
                                  value={message}
                                  onChange={this.handleChange}
                                  required
                                  style={{ minHeight: '180px' }}
                                />
                              </FormGroup>
                              <Button
                                block
                                className="btn-round"
                                color="default"
                                size="lg"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? 'Sending...' : 'Send Message'}
                              </Button>
                            </Form>
                          </>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
          </main>
          <SimpleFooter />
        </div>
      </>
    );
  }
}

export default Contact;
